var _a;
import { TableFormattingDefault } from "components/custom-table/settings/TableFormatSettingsModal";
import TableStateClass from "components/custom-table/TableStateClass";
import MetaData from "components/metadata/MetaData";
import { defaultPermissions } from "components/metadata/utils";
class TableSettings extends MetaData {
    formatting;
    name;
    state;
    table;
    constructor(response) {
        super(response);
        this.formatting = response.formatting;
        this.state = new TableStateClass(response.state);
        this.table = response.table;
        this.name = response.name;
    }
    static create(tableName) {
        return new _a({
            formatting: TableFormattingDefault,
            state: TableStateClass.DEFAULT,
            table: tableName
        });
    }
    #clone() {
        return new _a({
            createdBy: this.createdBy,
            createdDate: this.createdDate,
            id: this.id,
            lastModifiedBy: this.lastModifiedBy,
            lastModifiedDate: this.lastModifiedDate,
            permissions: this.permissions,
            formatting: this.formatting,
            name: this.name,
            state: this.state,
            table: this.table
        });
    }
    equals(other) {
        return this.name === other.name && this.table === other.table && this.formatting.booleanFormat === other.formatting.booleanFormat && this.formatting.dateFormat === other.formatting.dateFormat && this.formatting.exportHeaders === other.formatting.exportHeaders && this.formatting.groupData === other.formatting.groupData && MetaData.equals(this, other) && this.state.equals(other.state);
    }
    updateState(updated) {
        const clone = this.#clone();
        clone.state = new TableStateClass(updated);
        return clone;
    }
    setName(name) {
        const clone = this.#clone();
        clone.name = name;
        return clone;
    }
    setFormatting(formatting) {
        const clone = this.#clone();
        clone.formatting = formatting;
        return clone;
    }
    removeMeta() {
        const clone = this.#clone();
        delete clone.id;
        delete clone.createdBy;
        delete clone.createdDate;
        delete clone.lastModifiedBy;
        delete clone.lastModifiedDate;
        clone.permissions = defaultPermissions;
        return clone;
    }
    setPermissions(permissions) {
        const clone = this.#clone();
        clone.permissions = permissions;
        return clone;
    }
}
_a = TableSettings;
export default TableSettings;
